import { defineComponent as _defineComponent } from 'vue'
import {
  nextTick,
  onMounted,
  onUnmounted,
  PropType,
  ref,
} from "vue";

import {
  updateIdentityUser,
  UpdateIdentityUserRequest,
} from "@/components/children/identityUsers/scripts";

import {
  User,
} from "@/scripts/Common";

import {
  isSmallerOrEqualToMaxLength,
} from "@/scripts/Common/validators";

import {
  HelperFunctions,
  isEmpty,
} from "@/scripts/Common/HelperFunctions";

import {
  MAX_LENGTH_FIRST_NAME,
  MAX_LENGTH_LAST_NAME,
} from "@/components/children/identityUsers/constants";

import {
  VForm,
} from "vuetify/lib/components";


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateIdentityUserDialog',
  props: {
  user: {
    required: true,
    type: Object as PropType<User>
  }
},
  emits: [
  'onDialogCancel',
  'onDialogConfirm',
  'onFetchError'
],
  setup(__props, { emit: emits }) {

const props = __props;





const form = ref<InstanceType<typeof VForm>>();
const updateRequest = ref<UpdateIdentityUserRequest>({
  email: props.user?.email,
  firstName: props.user?.firstName,
  lastName: props.user?.lastName,
  isEmailVerified: props.user?.isEmailVerified,
})

const isValid = ref(false);
const isDialogVisible = ref(false);

const onHandleDialogCancel = () => {
  emits('onDialogCancel');
}

const onHandleDialogError = (error: any) => {
  emits('onFetchError', { error });
}

const onHandleDialogConfirm = async () => {
  if(!props.user) return;
  // send empty values as undefined. Empty strings will throw validation errors
  // which means you will not be able to remove optional values, but thats an issue with the Auth0 sdk
  if(!updateRequest.value.email) updateRequest.value.email = undefined;
  if(!updateRequest.value.firstName) updateRequest.value.firstName = undefined;
  if(!updateRequest.value.lastName) updateRequest.value.lastName = undefined;

  const { error } = await updateIdentityUser(props.user.userId, updateRequest.value);

  if(error){
    onHandleDialogError( { error });
    return
  }

  emits('onDialogConfirm')
}

const validateForm = () => form.value?.validate();

onMounted( async () => {
  isDialogVisible.value = true;
  await nextTick();
  validateForm();
});

onUnmounted(() => {
  isDialogVisible.value = false;
})


return { __sfc: true,emits, props, form, updateRequest, isValid, isDialogVisible, onHandleDialogCancel, onHandleDialogError, onHandleDialogConfirm, validateForm, isSmallerOrEqualToMaxLength, HelperFunctions, MAX_LENGTH_FIRST_NAME, MAX_LENGTH_LAST_NAME, VForm }
}

})